var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuStaffOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.398 3.083a1 1 0 01.594 1.041L15.132 11H23a1 1 0 01.768 1.64l-10 12a1 1 0 01-1.76-.764l.86-6.876H5a1 1 0 01-.768-1.64l10-12a1 1 0 011.166-.277zM7.135 15H14a1 1 0 01.992 1.124l-.577 4.616 6.45-7.74H14a1 1 0 01-.992-1.124l.577-4.615L7.135 15z"
  })));
}
export default SvgMenuStaffOutline;